document.addEventListener('DOMContentLoaded', function () {
    document.documentElement.classList.add('has-section5-sequence');

    var zipDebugEnabled = window.location.search.indexOf('zipDebug=1') !== -1;
    var productDetailZipGoldHeroButton = document.querySelector('.product-detail-zip-gold-hero-button');
    var productDetailZipGoldSection5Instances = [];
    var productDetailZipGoldSection7SwiperElement = document.querySelector('.product-detail-zip-gold-section7-swiper');
    var productDetailZipGoldSection15SwiperElement = document.querySelector('.product-detail-zip-gold-section15-swiper');
    var productDetailZipGoldSection16SwiperElement = document.querySelector('.product-detail-zip-gold-section16-swiper');
    var productDetailZipGoldSection16NavButtons = Array.from(
        document.querySelectorAll('.product-detail-zip-gold-section16-nav-button')
    );
    var productDetailZipGoldSection16Nav = document.querySelector('.product-detail-zip-gold-section16-nav');
    var productDetailZipGoldSection17Items = Array.from(
        document.querySelectorAll('.product-detail-zip-gold-section17-collapse-expand')
    );
    var productDetailZipGoldVideoModal = document.querySelector('.product-detail-zip-gold-video-modal');
    var productDetailZipGoldVideoModalFrame = document.querySelector('.product-detail-zip-gold-video-modal-frame');
    var productDetailZipGoldVideoModalCloseTriggers = Array.from(
        document.querySelectorAll('[data-video-modal-close]')
    );

    function zipDebugLog() {
        if (!zipDebugEnabled || !window.console || typeof window.console.log !== 'function') {
            return;
        }

        window.console.log.apply(window.console, arguments);
    }

    function initProductDetailZipGoldSection3(sectionRoot) {
        if (!sectionRoot || sectionRoot.dataset.section3Initialized === 'true' || typeof Swiper === 'undefined') {
            return;
        }

        var swiperElement = sectionRoot.querySelector('.product-detail-zip-gold-section3-swiper');
        var pagination = sectionRoot.querySelector('.product-detail-zip-gold-section3-pagination');
        var paginationItems = Array.from(
            sectionRoot.querySelectorAll('.product-detail-zip-gold-section3-pagination-flex')
        );
        var nav = sectionRoot.querySelector('.product-detail-zip-gold-section3-nav');
        var navButtons = Array.from(
            sectionRoot.querySelectorAll('.product-detail-zip-gold-section3-nav-button')
        );
        var wheelLocked = false;
        var swiper;

        if (!swiperElement) {
            return;
        }

        function setPaginationActive(activeIndex) {
            paginationItems.forEach(function (item, index) {
                var isActive = index === activeIndex;
                item.classList.toggle('product-detail-zip-gold-section3-pagination-active', isActive);
                item.setAttribute('aria-current', isActive ? 'true' : 'false');
            });

            navButtons.forEach(function (button, index) {
                var isActive = index === activeIndex;
                button.setAttribute('aria-current', isActive ? 'true' : 'false');

                if (isActive && nav) {
                    var targetScrollLeft = button.offsetLeft - ((nav.clientWidth - button.offsetWidth) / 2);
                    var maxScrollLeft = nav.scrollWidth - nav.clientWidth;
                    targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

                    nav.scrollTo({
                        left: targetScrollLeft,
                        behavior: 'smooth'
                    });
                }
            });
        }

        swiper = new Swiper(swiperElement, {
            slidesPerView: 1,
            spaceBetween: 30,
            speed: 500,
            allowTouchMove: false,
            breakpoints: {
                768: {
                    allowTouchMove: true
                }
            }
        });

        setPaginationActive(swiper.activeIndex);

        swiper.on('slideChange', function () {
            setPaginationActive(swiper.activeIndex);
        });

        paginationItems.forEach(function (item) {
            item.addEventListener('click', function () {
                swiper.slideTo(Number(item.dataset.slideIndex));
            });

            item.addEventListener('keydown', function (event) {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    swiper.slideTo(Number(item.dataset.slideIndex));
                }
            });

            item.addEventListener('mouseenter', function () {
                var slideIndex = Number(item.dataset.slideIndex);
                swiper.slideTo(slideIndex);
                setPaginationActive(slideIndex);
            });
        });

        navButtons.forEach(function (button) {
            button.addEventListener('click', function () {
                swiper.slideTo(Number(button.dataset.slideIndex));
            });
        });

        if (pagination) {
            pagination.addEventListener('wheel', function (event) {
                event.preventDefault();

                if (wheelLocked || swiper.animating || !event.deltaY) {
                    return;
                }

                wheelLocked = true;

                if (event.deltaY > 0) {
                    swiper.slideNext();
                } else {
                    swiper.slidePrev();
                }

                window.setTimeout(function () {
                    wheelLocked = false;
                }, 500);
            }, { passive: false });
        }

        sectionRoot.dataset.section3Initialized = 'true';
    }

    function initProductDetailZipGoldSection5(sectionRoot) {
        if (!sectionRoot || sectionRoot.dataset.section5Initialized === 'true') {
            return;
        }

        var desktopImage = sectionRoot.querySelector('.product-detail-zip-gold-section5-image .custom-mobile-hidden');
        var mobileImage = sectionRoot.querySelector('.product-detail-zip-gold-section5-image .custom-mobile-show');
        var overlay = sectionRoot.querySelector('.product-detail-zip-gold-section5-overlay');
        var explodedItems = Array.from(
            sectionRoot.querySelectorAll('.product-detail-zip-gold-section5-exploded-item')
        );
        var stage = 0;
        var animating = false;

        if (!overlay || !explodedItems.length) {
            zipDebugLog('[ZIP][section5] init skipped', {
                hasOverlay: !!overlay,
                explodedItemCount: explodedItems.length
            });
            return;
        }

        function updateStage() {
            explodedItems.forEach(function (item, index) {
                item.classList.toggle('is-visible', index < stage);
            });

            zipDebugLog('[ZIP][section5] stage updated', {
                stage: stage,
                visibleCount: stage,
                total: explodedItems.length
            });
        }

        function getActiveImageElement() {
            return window.innerWidth <= 767 ? mobileImage : desktopImage;
        }

        function getMeasuredImageTarget() {
            var activeElement = getActiveImageElement();

            if (!activeElement) {
                return null;
            }

            return activeElement.tagName === 'IMG'
                ? activeElement
                : activeElement.querySelector('img');
        }

        function getDesignSize(image) {
            if (window.innerWidth <= 767) {
                return {
                    width: image && image.naturalWidth ? image.naturalWidth : 731,
                    height: image && image.naturalHeight ? image.naturalHeight : 1070
                };
            }

            return {
                width: image && image.naturalWidth ? image.naturalWidth : 1920,
                height: image && image.naturalHeight ? image.naturalHeight : 1438
            };
        }

        function syncOverlay() {
            var activeElement = getActiveImageElement();
            var activeImage = getMeasuredImageTarget();
            var designSize;

            if (!activeElement || !overlay || !activeElement.clientWidth) {
                zipDebugLog('[ZIP][section5] sync skipped', {
                    hasActiveElement: !!activeElement,
                    hasOverlay: !!overlay,
                    clientWidth: activeElement ? activeElement.clientWidth : 0
                });
                return;
            }

            designSize = getDesignSize(activeImage);

            overlay.style.width = designSize.width + 'px';
            overlay.style.height = designSize.height + 'px';
            overlay.style.transform = 'scale(' + (activeElement.clientWidth / designSize.width) + ')';

            zipDebugLog('[ZIP][section5] overlay synced', {
                clientWidth: activeElement.clientWidth,
                designWidth: designSize.width,
                designHeight: designSize.height,
                scale: activeElement.clientWidth / designSize.width
            });
        }

        function isActive() {
            if (window.innerWidth <= 767) {
                return false;
            }

            var rect = sectionRoot.getBoundingClientRect();
            var viewportHeight = window.innerHeight || document.documentElement.clientHeight;
            var topThreshold = viewportHeight * 0.2;
            var bottomThreshold = viewportHeight * 0.8;

            return rect.bottom > topThreshold && rect.top < bottomThreshold;
        }

        function step(direction) {
            if (animating) {
                zipDebugLog('[ZIP][section5] step blocked: animating');
                return false;
            }

            var nextStage = stage + direction;
            nextStage = Math.max(0, Math.min(explodedItems.length, nextStage));

            if (nextStage === stage) {
                zipDebugLog('[ZIP][section5] step blocked: boundary', {
                    direction: direction,
                    stage: stage,
                    total: explodedItems.length
                });
                return false;
            }

            animating = true;
            stage = nextStage;
            updateStage();

            zipDebugLog('[ZIP][section5] step applied', {
                direction: direction,
                stage: stage
            });

            window.setTimeout(function () {
                animating = false;
            }, 400);

            return true;
        }

        [desktopImage, mobileImage].forEach(function (imageElement) {
            var actualImage;

            if (!imageElement) {
                return;
            }

            actualImage = imageElement.tagName === 'IMG'
                ? imageElement
                : imageElement.querySelector('img');

            if (actualImage && !actualImage.complete) {
                actualImage.addEventListener('load', syncOverlay);
            }

            if ('ResizeObserver' in window) {
                new ResizeObserver(syncOverlay).observe(imageElement);
            }
        });

        if ('ResizeObserver' in window && overlay.parentElement) {
            new ResizeObserver(syncOverlay).observe(overlay.parentElement);
        }

        updateStage();
        syncOverlay();

        productDetailZipGoldSection5Instances.push({
            root: sectionRoot,
            syncOverlay: syncOverlay,
            isActive: isActive,
            step: step,
            isAnimating: function () {
                return animating;
            },
            getStage: function () {
                return stage;
            },
            getItemCount: function () {
                return explodedItems.length;
            }
        });

        sectionRoot.dataset.section5Initialized = 'true';
        zipDebugLog('[ZIP][section5] initialized', {
            explodedItemCount: explodedItems.length,
            sectionTop: sectionRoot.getBoundingClientRect().top
        });
    }

    function setProductDetailZipGoldSection16NavActive(activeIndex) {
        productDetailZipGoldSection16NavButtons.forEach(function (button, index) {
            var isActive = index === activeIndex;
            button.setAttribute('aria-current', isActive ? 'true' : 'false');

            if (isActive && productDetailZipGoldSection16Nav) {
                var targetScrollLeft = button.offsetLeft - ((productDetailZipGoldSection16Nav.clientWidth - button.offsetWidth) / 2);
                var maxScrollLeft = productDetailZipGoldSection16Nav.scrollWidth - productDetailZipGoldSection16Nav.clientWidth;
                targetScrollLeft = Math.max(0, Math.min(targetScrollLeft, maxScrollLeft));

                productDetailZipGoldSection16Nav.scrollTo({
                    left: targetScrollLeft,
                    behavior: 'smooth'
                });
            }
        });
    }

    function setProductDetailZipGoldSection17Open(item, isOpen) {
        var question = item.querySelector('.product-detail-zip-gold-section17-question');

        item.classList.toggle('is-open', isOpen);

        if (question) {
            question.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        }
    }

    function getProductDetailZipGoldSection15Origin() {
        return /^https?:\/\//.test(window.location.origin) ? window.location.origin : '';
    }

    function getProductDetailZipGoldSection15EmbedSrc(videoId, autoplay) {
        var params = new URLSearchParams({
            enablejsapi: '1',
            playsinline: '1',
            rel: '0'
        });
        var origin = getProductDetailZipGoldSection15Origin();

        if (origin) {
            params.set('origin', origin);
        }

        if (autoplay) {
            params.set('autoplay', '1');
        }

        return 'https://www.youtube.com/embed/' + videoId + '?' + params.toString();
    }

    function closeProductDetailZipGoldVideoModal() {
        if (!productDetailZipGoldVideoModal || productDetailZipGoldVideoModal.hidden) {
            return;
        }

        productDetailZipGoldVideoModal.hidden = true;
        document.body.classList.remove('product-detail-zip-gold-video-modal-open');

        if (productDetailZipGoldVideoModalFrame) {
            productDetailZipGoldVideoModalFrame.innerHTML = '';
        }
    }

    function openProductDetailZipGoldVideoModal(videoId) {
        if (!productDetailZipGoldVideoModal || !productDetailZipGoldVideoModalFrame || !videoId) {
            return;
        }

        var iframe = document.createElement('iframe');

        iframe.src = getProductDetailZipGoldSection15EmbedSrc(videoId, true);
        iframe.title = 'YouTube video player';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.allowFullscreen = true;

        productDetailZipGoldVideoModalFrame.innerHTML = '';
        productDetailZipGoldVideoModalFrame.appendChild(iframe);
        productDetailZipGoldVideoModal.hidden = false;
        document.body.classList.add('product-detail-zip-gold-video-modal-open');
    }

    function postMessageToProductDetailZipGoldSection15Player(videoCard, command) {
        var iframe = videoCard.querySelector('iframe');

        if (!iframe || !iframe.contentWindow) {
            return;
        }

        iframe.contentWindow.postMessage(JSON.stringify({
            event: 'command',
            func: command,
            args: []
        }), '*');
    }

    function pauseProductDetailZipGoldSection15Video(videoCard) {
        videoCard.classList.remove('is-playing');
        videoCard.dataset.autoplayOnReady = 'false';
        postMessageToProductDetailZipGoldSection15Player(videoCard, 'pauseVideo');
    }

    function ensureProductDetailZipGoldSection15Player(videoCard, autoplayOnReady) {
        var videoFrame = videoCard.querySelector('.product-detail-zip-gold-section15-video-frame');
        var existingIframe = videoFrame.querySelector('iframe');
        var videoId = videoCard.dataset.videoId;

        if (autoplayOnReady) {
            videoCard.dataset.autoplayOnReady = 'true';
        }

        if (existingIframe) {
            if (autoplayOnReady && videoCard.dataset.ready === 'true') {
                videoCard.classList.add('is-playing');
                postMessageToProductDetailZipGoldSection15Player(videoCard, 'playVideo');
            }

            return existingIframe;
        }

        var iframe = document.createElement('iframe');

        iframe.src = getProductDetailZipGoldSection15EmbedSrc(videoId);
        iframe.title = 'YouTube video player';
        iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
        iframe.referrerPolicy = 'strict-origin-when-cross-origin';
        iframe.allowFullscreen = true;
        iframe.loading = 'lazy';

        iframe.addEventListener('load', function () {
            videoCard.dataset.ready = 'true';
            videoCard.classList.add('is-ready');

            if (videoCard.dataset.autoplayOnReady === 'true') {
                videoCard.classList.add('is-playing');
                postMessageToProductDetailZipGoldSection15Player(videoCard, 'playVideo');
                videoCard.dataset.autoplayOnReady = 'false';
            }
        });

        videoFrame.appendChild(iframe);

        return iframe;
    }

    function playProductDetailZipGoldSection15Video(videoCard) {
        ensureProductDetailZipGoldSection15Player(videoCard, true);

        if (videoCard.dataset.ready === 'true') {
            videoCard.classList.add('is-playing');
            postMessageToProductDetailZipGoldSection15Player(videoCard, 'playVideo');
            videoCard.dataset.autoplayOnReady = 'false';
        }
    }

    function preloadProductDetailZipGoldSection15Slide(swiper, slideIndex) {
        var totalSlides = swiper.slides.length;
        var normalizedIndex = ((slideIndex % totalSlides) + totalSlides) % totalSlides;
        var slide = swiper.slides[normalizedIndex];
        var videoCard = slide ? slide.querySelector('.product-detail-zip-gold-section15-video') : null;

        if (videoCard) {
            ensureProductDetailZipGoldSection15Player(videoCard, false);
        }
    }

    function preloadProductDetailZipGoldSection15VisibleVideos(swiper) {
        if (!swiper || typeof swiper.activeIndex !== 'number' || !swiper.slides || !swiper.slides.length) {
            return;
        }

        preloadProductDetailZipGoldSection15Slide(swiper, swiper.activeIndex);
        preloadProductDetailZipGoldSection15Slide(swiper, swiper.activeIndex - 1);
        preloadProductDetailZipGoldSection15Slide(swiper, swiper.activeIndex + 1);
    }

    function pauseInactiveProductDetailZipGoldSection15Videos(swiper) {
        if (!swiper || !swiper.el || typeof swiper.el.querySelectorAll !== 'function') {
            return;
        }

        Array.from(swiper.el.querySelectorAll('.product-detail-zip-gold-section15-video')).forEach(function (videoCard) {
            var slide = videoCard.closest('.swiper-slide');

            if (!slide || !slide.classList.contains('swiper-slide-active')) {
                pauseProductDetailZipGoldSection15Video(videoCard);
            }
        });
    }

    Array.from(document.querySelectorAll('.product-detail-zip-gold-section3')).forEach(function (sectionRoot) {
        initProductDetailZipGoldSection3(sectionRoot);
    });
    Array.from(document.querySelectorAll('.product-detail-zip-gold-section5')).forEach(function (sectionRoot) {
        initProductDetailZipGoldSection5(sectionRoot);
    });
    var productDetailZipGoldSection7Swiper = productDetailZipGoldSection7SwiperElement
        ? new Swiper(productDetailZipGoldSection7SwiperElement, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 12,
            loop: true,
            loopedSlides: 3,
            initialSlide: 1,
            speed: 600,
            autoplay: {
                delay: 5000,
                disableOnInteraction: false,
            },
            navigation: {
                nextEl: '.product-detail-zip-gold-section7-button-next',
                prevEl: '.product-detail-zip-gold-section7-button-prev',
            },
            breakpoints: {
                768: {
                    spaceBetween: 28,
                },
            },
        })
        : null;
    var productDetailZipGoldSection15Swiper = productDetailZipGoldSection15SwiperElement
        ? new Swiper(productDetailZipGoldSection15SwiperElement, {
            slidesPerView: 'auto',
            centeredSlides: true,
            spaceBetween: 12,
            loop: true,
            loopedSlides: 4,
            initialSlide: 1,
            speed: 600,
            pagination: {
                el: '.product-detail-zip-gold-section15-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.product-detail-zip-gold-section15-button-next',
                prevEl: '.product-detail-zip-gold-section15-button-prev',
            },
            breakpoints: {
                768: {
                    spaceBetween: 28,
                },
            },
        })
        : null;
    var productDetailZipGoldSection16Swiper = productDetailZipGoldSection16SwiperElement
        ? new Swiper(productDetailZipGoldSection16SwiperElement, {
            slidesPerView: 1,
            spaceBetween: 24,
            speed: 500,
            autoHeight: true
        })
        : null;

    if (productDetailZipGoldSection16Swiper) {
        setProductDetailZipGoldSection16NavActive(productDetailZipGoldSection16Swiper.activeIndex);
        productDetailZipGoldSection16Swiper.on('slideChange', function () {
            setProductDetailZipGoldSection16NavActive(productDetailZipGoldSection16Swiper.activeIndex);
        });
    }

    if (productDetailZipGoldSection15Swiper) {
        preloadProductDetailZipGoldSection15VisibleVideos(productDetailZipGoldSection15Swiper);
        pauseInactiveProductDetailZipGoldSection15Videos(productDetailZipGoldSection15Swiper);
        productDetailZipGoldSection15Swiper.on('slideChangeTransitionStart', function () {
            pauseInactiveProductDetailZipGoldSection15Videos(productDetailZipGoldSection15Swiper);
            preloadProductDetailZipGoldSection15VisibleVideos(productDetailZipGoldSection15Swiper);
        });
    }

    if (productDetailZipGoldSection15SwiperElement) {
        productDetailZipGoldSection15SwiperElement.addEventListener('click', function (event) {
            var trigger = event.target.closest('.product-detail-zip-gold-section15-video-trigger');

            if (!trigger) {
                return;
            }

            var slide = trigger.closest('.swiper-slide');
            var videoCard = trigger.closest('.product-detail-zip-gold-section15-video');
            var slideIndex = Number(slide.getAttribute('data-swiper-slide-index'));

            if (!productDetailZipGoldSection15Swiper || !slide || !videoCard) {
                return;
            }

            if (!slide.classList.contains('swiper-slide-active')) {
                productDetailZipGoldSection15Swiper.slideToLoop(slideIndex);
                return;
            }

            playProductDetailZipGoldSection15Video(videoCard);
        });
    }

    productDetailZipGoldSection16NavButtons.forEach(function (button) {
        button.addEventListener('click', function () {
            if (!productDetailZipGoldSection16Swiper) {
                return;
            }

            productDetailZipGoldSection16Swiper.slideTo(Number(button.dataset.slideIndex));
        });
    });

    if (productDetailZipGoldHeroButton) {
        productDetailZipGoldHeroButton.addEventListener('click', function () {
            openProductDetailZipGoldVideoModal(productDetailZipGoldHeroButton.dataset.videoId);
        });
    }

    productDetailZipGoldVideoModalCloseTriggers.forEach(function (trigger) {
        trigger.addEventListener('click', closeProductDetailZipGoldVideoModal);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
            closeProductDetailZipGoldVideoModal();
        }
    });

    productDetailZipGoldSection17Items.forEach(function (item) {
        var question = item.querySelector('.product-detail-zip-gold-section17-question');

        if (!question) {
            return;
        }

        setProductDetailZipGoldSection17Open(item, false);

        question.addEventListener('click', function () {
            setProductDetailZipGoldSection17Open(item, !item.classList.contains('is-open'));
        });

        question.addEventListener('keydown', function (event) {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                setProductDetailZipGoldSection17Open(item, !item.classList.contains('is-open'));
            }
        });
    });

    document.addEventListener('click', function (event) {
        var item = event.target.closest('.product-detail-zip-gold-section2-item--link');

        if (!item) {
            return;
        }

        var targetId = item.dataset.targetId;

        if (!targetId) {
            return;
        }

        var targetElement = document.getElementById(targetId);

        if (!targetElement) {
            zipDebugLog('[ZIP][section2] target not found', { targetId: targetId });
            return;
        }

        event.preventDefault();
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    document.addEventListener('shopify:section:load', function (event) {
        Array.from(event.target.querySelectorAll('.product-detail-zip-gold-section3')).forEach(function (sectionRoot) {
            initProductDetailZipGoldSection3(sectionRoot);
        });
        Array.from(event.target.querySelectorAll('.product-detail-zip-gold-section5')).forEach(function (sectionRoot) {
            initProductDetailZipGoldSection5(sectionRoot);
        });
    });

    window.addEventListener('resize', function () {
        productDetailZipGoldSection5Instances.forEach(function (instance) {
            instance.syncOverlay();
        });
    });

    function getVisibleHeroVideo() {
        var hero = document.querySelector('.product-detail-zip-gold-hero');
        if (!hero) {
            return null;
        }
        var videos = hero.querySelectorAll('.product-detail-zip-gold-hero-video');
        for (var i = 0; i < videos.length; i++) {
            if (videos[i].offsetParent !== null) {
                return videos[i];
            }
        }
        return videos.length > 0 ? videos[0] : null;
    }

    function initHeroVideo() {
        var hero = document.querySelector('.product-detail-zip-gold-hero');
        var heroVideo = getVisibleHeroVideo();

        if (!hero || !heroVideo) {
            return;
        }

        var started = false;

        heroVideo.addEventListener('ended', function () {
            started = true;
        });

        var observer = new IntersectionObserver(function (entries) {
            if (started) {
                return;
            }

            var video = getVisibleHeroVideo();
            if (!video) {
                return;
            }

            entries.forEach(function (entry) {
                if (entry.isIntersecting && entry.intersectionRatio >= 0.9) {
                    started = true;
                    requestAnimationFrame(function () {
                        var playPromise = video.play();
                        if (playPromise && typeof playPromise.catch === 'function') {
                            playPromise.catch(function () {});
                        }
                    });
                }
            });
        }, {
            threshold: [0.9]
        });

        observer.observe(hero);
    }

    initHeroVideo();

    window.addEventListener('wheel', function (event) {
        var activeInstance;

        if (!event.deltaY) {
            return;
        }

        activeInstance = productDetailZipGoldSection5Instances.find(function (instance) {
            return instance.isActive();
        });

        zipDebugLog('[ZIP][section5] wheel', {
            deltaY: event.deltaY,
            instanceCount: productDetailZipGoldSection5Instances.length,
            hasActiveInstance: !!activeInstance,
            activeStage: activeInstance ? activeInstance.getStage() : null,
            activeTotal: activeInstance ? activeInstance.getItemCount() : null
        });

        if (!activeInstance || activeInstance.isAnimating()) {
            return;
        }

        if (event.deltaY > 0 && activeInstance.getStage() < activeInstance.getItemCount()) {
            event.preventDefault();
            activeInstance.step(1);
        } else if (event.deltaY < 0 && activeInstance.getStage() > 0) {
            event.preventDefault();
            activeInstance.step(-1);
        }
    }, { passive: false });
});
